import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const Title = styled(Heading)``;

export const TitleContent = styled.div<{ theme: Theme }>`
  display: flex;  
  border-bottom: ${getColor('borderSecondary')} 1px solid;
  margin-bottom: 12px;
  flex-direction: column;
  
  &.the-latest {
    margin-bottom: unset;
  }

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
    align-items: center;
    gap: 16px;

    &.has-sponsor {
      .hub-title {
        max-width: 70%;
      }
      .hub-sponsor {
        max-width: 30%;
      }
    }
  }
`;

export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 20px;
  align-self: flex-end;
  font-weight: 400;
  line-height: 24px;
  text-align: right;

  @media (${breakpoint.lgMin}) {
    padding-top: 4px;
  }
`;
